import { Controller, useFormContext } from "react-hook-form";
import { FormHelperText, Box } from "@mui/material";
import {
  StyledRadioGroup,
  StyledRadio,
  StyledFormControlLabel,
  StyledLabel,
} from "./StyleInputs";

const RadioGroupField = ({ field }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const errorMessage = errors[field.id]?.message;

  return (
    <Box sx={{ mb: 3 }}>
      <StyledLabel required={field.required}>{field.label}</StyledLabel>
      <Controller
        name={field.id}
        control={control}
        defaultValue=""
        rules={{
          required: field.required ? `${field.label} is required` : false,
        }}
        render={({ field: { onChange, value } }) => (
          <>
            <StyledRadioGroup value={value} onChange={onChange}>
              {field.options?.map((option) => (
                <StyledFormControlLabel
                  key={option.value}
                  value={option.value}
                  control={<StyledRadio />}
                  label={option.label}
                />
              ))}
            </StyledRadioGroup>
            {errorMessage && (
              <FormHelperText error>{errorMessage}</FormHelperText>
            )}
          </>
        )}
      />
    </Box>
  );
};

export default RadioGroupField;
